import React from "react";
import PageHeader from "../Common/PageHeader";
import LibraryIcon from "../../assets/icons/library_puzzle.svg2";
import { Link } from "react-router-dom";

export default function LandingPage({
  heading,
  links,
  subheading = "",
}: {
  heading: string;
  subheading?: string;
  links: any[];
}) {
  return (
    <>
      <PageHeader
        heading={heading}
        subheading={subheading}
        children={undefined}
        Icon={LibraryIcon}
      />
      <div className="d-flex flex-wrap justify-content-center gap-5 my-5">
        {links.map((link) => (
          <Link
            to={link.href}
            className="btn-white p-5 rounded-3 d-flex flex-column justify-content-center align-items-center gap-2"
            style={{ width: 250 }}
          >
            <link.Icon width={80} />
            <h5 className="fw-bold my-2 text-center">{link.label}</h5>
          </Link>
        ))}
      </div>
    </>
  );
}
